import { NodeViewContent } from '@tiptap/react';
import { FC } from 'react';
import { RecordBlockSectionComponentProps } from './types';

export const RecordBlockGeneratedSection: FC<
  RecordBlockSectionComponentProps
> = () => {
  return <NodeViewContent />;
};
